<template lang="">
<div class="mt-8 push-web-responsive-note">
		<v-dialog v-model="confirm_cancel_visible" scrollable max-width="500px">
			<template v-slot:activator="{ on, attrs }">
			</template>
			<v-card>
				<v-card-title class="text-h5 grey lighten-2">
					<img style="width:20px" src="../../../../static/images/warning.svg" class="mr-4"> Confirmação de cancelamento</v-card-title>
				<v-divider></v-divider>
				<v-card-text style="min-height: 150px; fontSize: 16px" class="d-flex flex-column align-center justify-center">
					Tem certeza que deseja cancelar o agendamento <span class="font-weight-black">{{logTitle}} ?</span>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions class="justify-end">
					<v-btn color="grey lighten-2" class="text-capitalize" @click="confirm_cancel_visible = false">
						Fechar
					</v-btn>
					<v-btn color="red lighten-2" class="text-capitalize" @click="goCancelScheddule">
						Cancelar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
    <v-card class="filter--container d-flex">
			<span class="d-flex flex-row input">
				<input v-model="s_title" type="text" placeholder="Título" style="width: 100%">
				<img class="imgResponsive" style="width:20px" src="../../../../static/images/message.svg">
			</span>

			<span class="d-flex flex-row input">
				<input v-model="s_csvName" type="text" placeholder="Nome do CSV" style="width: 100%">
				<img class="imgResponsive" style="width:20px" src="../../../../static/images/message.svg">
			</span>
			<date-picker
				v-model="s_from"
				class="inputDataFilter input d-flex align-center"
				format="DD/MM/YYYY"
				placeholder="De"
				input-class="border"
				lang="pt-Br"
				time-title-format="DD/MM/YYYY"
	
			>
			</date-picker>
			<date-picker
				v-model="s_to"
				class="inputDataFilter input d-flex align-center"
				format="DD/MM/YYYY"
				placeholder="Até"
				input-class="border"
				time-title-format="DD/MM/YYYY"
	
			>
			</date-picker>
			
			<div class="button-wrapper d-flex justify-space-between">
				<button
					@click="filter"
          class="mr-5"
          :disabled="!disabled"
				>
					<clip-loader
						v-if="loading"
						:loading="loading"
						color="var(--white)"
						size="22px"
					/>
					<div
            v-if="!loading"
						class="button-wrapper--text"
						>
						<img src="../../../../static/images/search.svg">
						Buscar
					</div>
				</button>
				<button
					@click="clearForm"
          style="background: var(--white); border: 1px solid grey; color: var(--dark-grey)"
				>
					<clip-loader
						v-if="loadingClear"
						:loading="loadingClear"
						color="var(--black)"
						size="22px"
					/>
					<div
            v-if="!loadingClear"
						class="button-wrapper--text"
						>
						<img src="../../../../static/images/load.svg">
						Limpar
					</div>
				</button>
			</div>
    </v-card>

    <h4 style="fontSize: 20px" class="mt-12">Agendamentos</h4>
    <div v-if="!loadingData">
			<v-expansion-panels class="mt-5">
				<v-expansion-panel v-for="(item, index) in items" :key="index" class="mt-2 d-flex align-center flex-column rounded-lg" height="59" id="expansion-item">
					<v-expansion-panel-header class="d-flex align-center" style="padding: 10px 2px; position: initial;">
						<span class="rounded borderLeft" style=""></span>
						<div class="d-flex align-center justify-space-between">
							<div class="responsiveItemName">
								<span class="mr-9 font-weight-black widthResponsive">{{item.title}}</span>
							</div>
							<div class="d-flex align-center justify-space-between">
								<span class="font-weight-black">Agendado para: <span class="mr-9 ml-1">{{formatDate(item.scheduledDate)}}</span></span>
								<span class="font-weight-black">Horário: <span class="mr-9 ml-1"> {{formatHour(item.scheduledDate)}}</span></span>
								<div class="buttons_action">
									<router-link to="/duplicate-push-web" class="mr-6">
										<button
											class="b-4 d-flex justify-center align-center rounded duplicate"
											@click="setDuplicateForm(item)"
										>
											<img src="../../../../static/images/square.svg" />
										</button>
									</router-link>

									<button v-if="allowed_to_cancel.some(i => i.id === item.id)" class="mr-6 d-flex justify-center align-center remove"
										@click="handleCancel(item.csvName, item.id, item)"
									>
											<img src="../../../../static/images/trash.svg" />
									</button>
								</div>
							</div>
						</div>
					</v-expansion-panel-header>
					<v-expansion-panel-content class="ml-5 responsive-note">
						<div class="d-flex flex-column">
							<span class="font-weight-black mt-4">Arquivo</span>
							<span>{{item.fileName}}</span>
						</div>
						<div v-if="item.messageContent" class="d-flex flex-column">
							<span class="font-weight-black mt-4">Mensagem: </span>
							<span>{{item.messageContent}}</span>
						</div>
						<div class="d-flex flex-column">
							<span class="font-weight-black mt-4">Data de criação</span>
							<span>{{formatDate(item.dateAdded)}}</span>
						</div>
						<div v-if="item.urlRedirect" class="d-flex flex-row align-center mt-4">
							<span class="font-weight-black">Url do Redirect:</span>
							<span class="ml-2" style="width: 990px; word-break:break-word">{{item.urlRedirect}}</span>
						</div>
						<div class="d-flex flex-column align-start" v-if="item.button1Url">
							<span class="font-weight-black mt-4 mb-6">Botões:</span>
							<v-row>
								<v-col>
									<span class="btnRed mb-5">{{item.button1Text}}</span>
									<v-col class="d-flex flex-column mt-4">
										<span class="font-weight-black">Botão 1</span>
										<span style="width:300px">Url: {{item.button1Url}}</span>
									</v-col>
								</v-col>
								<v-col v-if="!!item.button2Text">
									<span class="btnRed">{{item.button2Text}}</span>
									<v-col class="d-flex flex-column mt-4">
										<span class="font-weight-black">Botão 2</span>
										<span>Url: {{item.button2Url}}</span>
									</v-col>
								</v-col>
							</v-row>
						</div>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
    </div>
		
    <div v-if="loadingData" class="mt-5 d-flex justify-center align-center rounded" style="background: var(--white); width: auto; height: 200px">
      <span>Dados não encontrados!</span>
    </div>

    <!-- Pagination -->
    <v-card class="mt-8 mb-1" v-if="!loadingData">
			<div v-if="!loading" class="list-footer">
				<span></span>
				<v-pagination
					v-model="page"
					:length="numberPages"
					color="#F0F1F3"
					total-visible="7"
					@input="nextPage">
				</v-pagination>
				<div class="goToPage">
					<span class="goToPage--text">
						Ir para página
					</span>
					<label>
						<input v-model="goToPage" type="text">
						<button @click="goToPageRequest" :disabled="disabledGoTo">
							<div class="button-wrapper--text">
								<i class="iconStyle icon-arrow-right d-flex justify-center align-center"></i>
							</div>
						</button>
						<span :class="showGoToPageHelpText ? '--show-helptext' : '--hide-helptext'" class="goToPage--helptext">
							A página deve estar entre 1 e {{numberPages}}
						</span>
					</label>
				</div>
			</div>
    </v-card>

		<div style="height: 5px"></div>

    <!-- Drwaer edit -->
    <v-navigation-drawer v-model="drawer" fixed overlay temporary right width="890" height="100vh" style="background: var(--grey-day-010)">
        <EditPush v-on:close="drawer = false" />
    </v-navigation-drawer>
</div>
</template>

<script>
// Libs
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
import {
    mapActions,
    mapMutations,
    mapState
} from "vuex";
import moment from "moment";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";

//
import VueCookies from 'vue-cookies'

// Component
import EditPush from "./EditPush.vue";

//mixins
import toaster from '../../../mixins/toaster'

export default {
		mixins: [toaster],
    components: {
        DatePicker,
        ClipLoader,
        EditPush,
    },
    data() {
        return {
            disabled: false,
            loading: false,
            page: 1,
            goToPage: 1,
            disabledGoTo: false,
            showGoToPageHelpText: false,
            s_title: "",
            s_csvName: "",
            s_from: "",
            s_to: "",
            search_message: "",
            drawer: false,
            service: "",
            date: "",
            loadingData: true,
            confirm_cancel_visible: false,
            csvCancel: '',
            idToCancel: 0,
						logTitle: '',
        };
    },
    async created() {
				const token = VueCookies.get('jwt-login')
        await this.getAllowedsToCancel(token);
        await this.filter();
        await this.numberOfPage;
    },
    computed: {
        ...mapState("PushWebLogs", {
            items: "items",
            services: "services",
            totalElements: "totalElements",
            current_page: "current_page",
            loadingClear: "loadingClear",
            totalPages: "totalPages",
            allowed_to_cancel: "allowed_to_cancel"
        }),
        numberPages() {
            return this.totalPages;
        },
        servicesList() {
            const serviceList = this.services ? this.services : [];
            return serviceList.map((service) => ({
                value: service.id,
                label: service.serviceName,
            }));
        },
    },
    methods: {
        ...mapActions("PushWebLogs", [
            "allPushWebSchedules",
            "getService",
            "filterLogstestes",
            "getAllowedsToCancel",
            "cancelScheddule",
        ]),
        ...mapMutations("PushWebLogs", {
            setCurrentPage: "SET_CURRENT_PAGE",
            setLogsToEdit: "SET_LOGS_TO_EDIT",
            setSeachEmailFilter: "SET_SEARCH_EMAIL_FILTER",
            setSeachMessageFilter: "SET_SEARCH_MESSAGE_FILTER",
            setloadingClear: "LOADING_CLEAR",
						setDate: 'SET_DATE'
        }),
				async nextPage (e) {
					this.goToPage = this.page
					this.setCurrentPage(e - 1)
					await this.filter()
				},
        handleCancel(csv_to_cancel, id, item) {
						this.logTitle = item.title
            this.csvCancel = csv_to_cancel;
            this.idToCancel = id;
            this.confirm_cancel_visible = true;
        },
        async goCancelScheddule() {
						const token = VueCookies.get('jwt-login')
            this.confirm_cancel_visible = false;
						try {
							await this.cancelScheddule({
								token: token,
								csvName: this.csvCancel,
								id: this.idToCancel
							})
							this.toaster(
								'Agendamento cancelado com sucesso!',
								'var(--green)',
								true
							)
							await this.filter()
						} catch (error) {
							this.toaster(
								error.message,
								'var(--red)',
								true
							)
						}
        },
        getSearch() {
					let search = "";				
					if (this.s_title) search += `&title=${this.s_title}`;
					if (this.s_csvName) search += `&csvName=${this.s_csvName}`;
		
					if (this.s_from) search += `&from=${moment(this.s_from).format('YYYY-MM-DD')}` 
					if (this.s_to) search += `&to=${moment(this.s_to).format('YYYY-MM-DD')}`
					return search;
        },
        async filter() {
					this.loadingData = true;
					this.loading = true
					let search = this.getSearch();
					const token = VueCookies.get('jwt-login')
					try {
						await this.allPushWebSchedules({
							token,
							search,
						});
						this.loadingData = false;
						this.loading = false
					} catch (error) {
						console.error(error);
					}
        },
        formatDate(date) {
					return moment(date).format("DD/MM/YYYY");
        },
        formatHour(date) {
					return moment(date).format("hh:mm");
        },
        async goToPageRequest() {
					this.loadingData = true;
					this.setCurrentPage(this.goToPage - 1);
					this.page = Number(this.goToPage)
					await this.filter();
					this.loadingData = false;
        },
        async clearForm() {
					this.loadingData = true;
					this.s_title = "";
					this.s_csvName = "";
					this.s_from = "";
					this.s_to = "";
					const search = ''
					this.setCurrentPage(0);
					this.page = 1;
					this.goToPage = 1;
					this.loadingData = true;

					const token = VueCookies.get('jwt-login')
					this.email = "";
					await this.allPushWebSchedules({
							search,
							token
					});
					this.loadingData = false;
					this.setloadingClear(false);
        },
        setDuplicateForm(item) {
            
					this.setLogsToEdit(item);
        },
    },
    watch: {
			goToPage() {
				if (this.goToPage < 1 || this.goToPage > this.numberOfPage) {
					this.showGoToPageHelpText = true;
					this.disabledGoTo = true;
				} else {
					this.showGoToPageHelpText = false;
					this.disabledGoTo = false;
				}
			},
			"s_title"() {
				this.s_title !== null
					? this.disabled = true
					: this.disabled = false
			},
			"s_csvName"() {
				this.s_csvName !== null
					? this.disabled = true
					: this.disabled = false
			},
			's_from'() {
				this.s_from !== null
					? this.disabled = true
					: this.disabled = false
			},
			's_to'() {
				this.s_to !== null
					? this.disabled = true
					: this.disabled = false
			},
    },
};
</script>
<style lang="scss" scoped>
.buttons_action {
	.duplicate {
		border: 2px solid var(--grey-day-020);
		height: 40px;
		width: 40px;
	}
	.remove {
		height: 40px;
		width: 40px;
		background: var(--red);
		border-radius: 4px;
		color: var(--white);
	}
}

.btnRed {
	min-width: 130px;
	background: var(--red);
	color: var(--white);
	padding: 17px;
	margin-top: 20px;
	margin-bottom: 20px;
	border-radius: 4px;
}

.mx-input-wrapper {
	margin-top: -8px;
}

.push-web-responsive-note {
    width: 1224px;

    .buttons_action {
        display: flex;
        justify-content: flex-end;
    }

    .vs__selected-options {
        width: 250px;
        padding-right: 20px;
    }

    .v-expansion-panel-header {
        padding: 7px 10px 7px 3px;
    }

    .mx-input {
        display: flex;
        height: 44px;
        border: none;
        outline: none;
    }

    .mx-input-wrapper {
        margin-top: -8px;
    }

    .filter--container {
        background: var(--white);
        border-radius: 4px;
        margin-bottom: 3.125rem;
        padding: 1.375rem;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        height: 88px;

        .input {
            border: 2px solid var(--grey-day-030);
            height: 48px;
            padding: 7px;
            margin-right: 20px;
            border-radius: 4px;
            padding-left: 0;
            border-radius: 4px !important;
            font-family: "DM Sans Regular", sans-serif;

            .mx-input-wrapper {
							padding-left: 0;
							font-family: "DM Sans Regular", sans-serif;
							width: 100% !important;
            }

            input {
                padding-left: 10px;
                font-family: "DM Sans Regular", sans-serif;
            }

            img {
                opacity: 0.5;
            }
        }
        .inputDataFilter {
            paddng: 7px; 
        }

        label:focus-within {
            border: 2px solid var(--grey);
        }

        .button-wrapper {
            display: flex;
            justify-content: flex-end;
            // max-width: 20%;

            &--text {
                display: flex;
                align-items: center;
            }

            button {
                background: var(--dark-red);
                border: none;
                border-radius: 4px;
                color: var(--white);
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: var(--dm-sans-medium);
                font-size: 1rem;
                padding: 0.875rem;
                min-height: 48px;
                width: 130px;
                max-width: 100%;

                img {
                    margin-right: 0.875rem;
                }
            }

            button:disabled {
                background: #dddddd;
                cursor: not-allowed;
            }
        }
    }

          // &:nth-child(1) {
          //   grid-row: 1;
          //   grid-column: 1 / -1;
          // }

          // &:nth-child(2) {
          //   grid-row: 2;
          //   grid-column: 1 / -1;
          // }

          // &:nth-child(3) {
          //   grid-row: 3;
          // }

          // &:nth-child(4) {
          //   grid-row: 3;
          // }

    .list-footer {
        background: var(--white);
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.75rem 2.625rem;
        margin: 80px 0 10px 0;
        height: 64px;
    }

    .v-pagination__navigation,
    .v-pagination__item {
			border: none;
			box-shadow: none;
    }

    .goToPage {
        &--text {
            font-size: 14px;
            font-family: var(--dm-sans-regular);
            color: var(--dark-grey);
            margin-right: 20px;
        }

        label {
            border: 2px solid var(--grey-day-030);
            background: var(--white);
            border-radius: 4px;
            box-sizing: border-box;
            max-width: 84px;
            width: 80px;
            padding: 10px;
            position: relative;

            input {
                width: 54px;
                font-size: 1rem;
                color: var(--grey);
                font-family: var(--dm-sans-regular);
            }

            button {
                position: absolute;
                border-radius: 50%;
                border: none;
                padding: 0;
                top: 11px;
                right: 8px;
                background: var(--grey);
                cursor: pointer;

                i {
                    color: var(--white);
                    font-size: 1.25rem;
                }
            }

            button:disabled {
                opacity: 0.6;
                cursor: not-allowed;
            }
        }

        &--helptext {
            font-family: var(--dm-sans-regular);
            position: absolute;
            font-size: 12px;
            width: 120px;
            text-align: center;
            top: -55px;
            left: -24px;
            background: var(--dark-red);
            padding: 8px;
            color: var(--light-grey);
            border-radius: 4px;
        }

        .--hide-helptext {
            display: none;
        }

        .--show-helptext {
            display: block;
        }
    }

    .iconStyle {
        width: 20px;
        height: 20px;
        background: transparent;
    }

    .borderLeft {
        height: 50px;
        max-width: 3px !important;
        width: 13px;
        background-color: var(--green);
        margin: 0 3px;
        position: absolute;
    }

    .v-expansion-panel--active .borderLeft {
        height: initial;
        // max-width: 3px !important;
        transition: 0.3s;
        width: 4px;
        background-color: var(--green);
        margin: 0px 3px;
        position: absolute;
        top: 9px;
        bottom: 9px;
    }
}

.v-application .widthResponsive {
    width: 10%;
    margin-left: 50px;
}


.responsive-note {
	max-width: 1185px;
	min-width: 1185px;
}

@media screen and (max-width: 1377px) {

	.responsive-note {
		max-width: 800px;
		min-width: 800px;
	}
	.responsiveItemName {
    display: flex;
    align-items: flex-start;
  }

	// .mx-input-wrapper {
	// 	width: 100% !important;
	// }

    .v-application {
        .widthResponsive {
            margin-top: 0;
        }

        .push-web-responsive-note {
            width: 830px;

            .filter--container {
                height: initial;

                &.d-flex {
									display: grid !important;
									grid-template-columns: 1fr 1fr;
									gap: 8px;
                }

                .button-wrapper {
									grid-row: 4;
									grid-column: 1 / -1;
									justify-self: flex-start;
                }

                .input {
									width: 100%;
									
									.mx-input-wrapper {
										width: 100% !important;
									}

									&:nth-child(1) {
											grid-row: 1;
											grid-column: 1 / -1;
									}

									&:nth-child(2) {
											grid-row: 2;
											grid-column: 1 / -1;
									}

									&:nth-child(3) {
											grid-row: 3;
									}

									&:nth-child(4) {
											grid-row: 3;
									}

									&.mx-datepicker:nth-child(3) {
											// margin-bottom: -48px;
											// width: 100%;
									}
                }
	
            }

            .v-expansion-panel--active {
                .borderLeft {
                    height: 320px;
                }
            }
        }
    }

    .push-web-responsive-note {
        // .filter--container {
        //     .mx-datepicker:nth-child(4) {
        //         // grid-column: 2;
        //         // grid-row: 3;
        //     }
        // }

        // .responsive-note {
				// 	max-width: 55%;
				// 	align-self: self-start;
				// 	margin-left: 27px !important;
        // }

        .widthResponsive {
            width: 200px;
        }

        .input {
            width: 114px;
        }

        .imgResponsive {
            display: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Contents/ScheduleMessage/SchedulePushWeb.vue